import {Component, inject, OnInit} from '@angular/core';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslateService} from '@ngx-translate/core';
import {DialogHelper} from '../../helper/dialog-helper';
import {SessionService} from '../../../../services/session.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements OnInit
{
  private sessionService = inject(SessionService);
  languageCd: string;

  public static showDialog(dialogService: DialogService, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PrivacyPolicyComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant('PRIVACY_POLICY'),
        width: DialogHelper.getDialogWidth(800),
        height: '90%'
      }));
  }

  ngOnInit(): void
  {
    this.languageCd = this.sessionService.languageCode;
  }
}
